(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-apparel-landing"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-tcc-carousel-button]');
    if (!button) return;

    const section = button.closest('.tcc-apparel-landing__featured--men-carousel');
    const carousel = section && section.querySelector('[data-tcc-carousel]');
    if (!carousel) return;

    const direction = Number(button.dataset.tccCarouselButton || 1);
    carousel.scrollBy({
      left: direction * carousel.clientWidth,
      behavior: 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-women-apparel-landing"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-tcc-carousel-button]');
    if (!button) return;

    const section = button.closest('.tcc-apparel-landing__featured--men-carousel');
    const carousel = section && section.querySelector('[data-tcc-carousel]');
    if (!carousel) return;

    const direction = Number(button.dataset.tccCarouselButton || 1);
    carousel.scrollBy({
      left: direction * carousel.clientWidth,
      behavior: 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-campaign-hero"] && !Shopify.designMode) return;
  try {
    
const setCampaignPaused = (hero, paused) => {
  if (!hero) return;

  hero.classList.toggle('is-paused', paused);

  const toggle = hero.querySelector('[data-v3-campaign-toggle]');
  if (!toggle) return;

  const pauseLabel = toggle.dataset.pauseLabel || 'Pause campaign animation';
  const playLabel = toggle.dataset.playLabel || 'Play campaign animation';

  toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
  toggle.setAttribute('aria-label', paused ? playLabel : pauseLabel);
};

const initializeCampaignHero = (root = document) => {
  root.querySelectorAll('.v3-campaign-hero').forEach((hero) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setCampaignPaused(hero, true);
    }
  });
};

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-v3-campaign-toggle]');
  if (!toggle) return;

  const hero = toggle.closest('.v3-campaign-hero');
  setCampaignPaused(hero, !hero.classList.contains('is-paused'));
});

document.addEventListener('DOMContentLoaded', () => initializeCampaignHero());
document.addEventListener('shopify:section:load', (event) => initializeCampaignHero(event.target));

  } catch(e) { console.error(e); }
})();
})();
